import React, { useCallback, useEffect, useState } from 'react';

import { IonApp, IonRouterOutlet } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { Route, Redirect, RouteProps, Switch } from 'react-router-dom';

import Menu from './components/Menu';

// Pages
import Auth from './pages/Auth';
import About from './pages/About';
import Words from './pages/Words';
import WordDetails from './pages/WordDetails';
import AddWord from './pages/AddWord';
import Signals from './pages/Signals';
import Home from './pages/Home';
import Logout from './pages/Logout';
import Profile from './pages/Profile'

import authService from './services/AuthService';
import userService from 'services/UserService';

import { User } from 'models/User';

import { analytics } from './providers/Firebase';

import * as Routers from './Routers';
import SinalDetails from './pages/SignalDetails';

interface PrivateRouteProps extends RouteProps {
  component: any;
  isAuthenticated: boolean
}

const PrivateRoute = (props: PrivateRouteProps) => {
  const { component: Component, location, ...rest } = props;

  return (
    <Route {...rest} render={(routeProps) => (
      props.isAuthenticated
        ? <Component {...routeProps} />
        : <Redirect to={{ pathname: Routers.AUTH_ROUTER, state: { from: location } }} />
    )} />
  )
}

const App: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

  const addedInfoInDatabase = useCallback(async () => {
    const user = User.userFromAuthUser(authService.user()!)
    await userService.saveIfNoExists(user)
  }, [])

  useEffect(() => {
    analytics.setAnalyticsCollectionEnabled(true)
    analytics.logEvent('page_view', {
      page_location: window.location.href
    })

    const unsubscribe = authService.observeAuth(isAuthenticated => {
      if (isAuthenticated) {
        addedInfoInDatabase()
      }

      setIsAuthenticated(isAuthenticated)
    })

    return () => {
      unsubscribe()
    }
  }, [addedInfoInDatabase])

  return (
    <IonApp>
      <IonReactRouter>
        <Menu />
        <IonRouterOutlet id="main">
          <Route path={Routers.SIGNALS_ROUTER} component={Signals} exact />
          <Route path={Routers.ABOUT_ROUTER} component={About} exact />
          <PrivateRoute path={Routers.PROFILE_ROUTER} component={Profile} isAuthenticated={isAuthenticated} exact />
          <Route path={Routers.AUTH_ROUTER} component={Auth} exact />
          <Route path={Routers.HOME_ROUTER} component={Home} exact />
          <Route path={Routers.WORDS_ROUTER} component={Words} exact />
          <PrivateRoute path={Routers.LOGOUT_ROUTER} isAuthenticated={isAuthenticated} component={Logout} exact />
        </IonRouterOutlet>
        <Switch>
          <Route path={Routers.DETAILS_SIGNAL_ROUTER} component={SinalDetails} exact />
          <Route path={Routers.DETAILS_WORD_ROUTER} component={WordDetails} exact />
          <PrivateRoute path={Routers.ADD_WORD_ROUTER} isAuthenticated={isAuthenticated} component={AddWord} exact />
        </Switch>
      </IonReactRouter>
    </IonApp>
  );
};

export default App;
